import styled from "styled-components/macro";

export const VatStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const VatLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* Roughly matches the eventual form height so the modal body doesn't
     jump when the country resolves. */
  min-height: 220px;
  width: 100%;
`;

export const AffirmationLabel = styled.div`
  /* Sub-heading rendered above the affirmation switch — clarifies the
     purpose of the toggle for users without a VAT ID handy. */
  color: var(--grey-1);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const AffirmationRow = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  /* The Switch component is the focusable target; the label wraps both so
     clicking the text toggles the switch. */
  /* The Switch thumb has a 10px box-shadow blur that the modal's
     overflow-x: hidden clips on the left when the row sits flush against
     the content edge. */
  margin-left: 12px;
`;

export const ReminderText = styled.div`
  /* Surfaced only when the affirmation switch is on — see the legal
     ordering in VatCheckoutStep.tsx (reminder above legal disclaimer). */
  color: var(--grey-1);
  font-size: 13px;
  margin-top: 12px;
  margin-left: 60px; /* AffirmationRow margin (12) + Switch (36) + gap (12) */
`;

export const LegalDisclaimer = styled.div`
  /* Article 196 / EU VAT Directive 2006/112/EC self-attestation legal
     copy. Rendered only when the user has self-attested as a business
     without a VAT ID. */
  color: var(--grey-2);
  font-size: 12px;
  margin-top: 8px;
  margin-left: 60px; /* AffirmationRow margin (12) + Switch (36) + gap (12) */
  line-height: 1.4;
`;

export const PriceSummary = styled.div`
  border: 1px solid var(--grey-3);
  border-radius: 12px;
  padding: 16px;
  font-variant-numeric: tabular-nums;
`;

export const VatStatusBadge = styled.span`
  color: ${(props) => (props.$exempt ? "#22c55e" : "var(--grey-1)")};
  font-size: 13px;
  margin-top: 8px;
  display: block;
`;

export const SectionLabel = styled.label`
  display: block;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  color: var(--grey-0);

  .optional {
    color: var(--grey-2);
    font-weight: 500;
    font-size: 13px;
    margin-left: 4px;
  }
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const SummaryDivider = styled.hr`
  border: none;
  border-top: 1px solid var(--grey-3);
  margin: 8px 0;
`;

export const SummaryTitle = styled.div`
  font-weight: 600;
  margin-bottom: 12px;
`;

export const HeaderSubtitle = styled.div`
  color: var(--grey-1);
  font-size: 14px;
  margin-bottom: 8px;
`;

/**
 * SW-8538 — Inline error block surfaced under the VAT ID input on a
 * 422 "tax_id_rejected" response from `/checkout/createVatSession`.
 *
 * Mirrors the `ErrorMessage` styled component on `feature/tax-id-page`
 * (TaxId/index.js) so the two surfaces look the same when shipped.
 */
export const VatInlineError = styled.div`
  font-size: 14px;
  color: var(--danger-color);
  background: var(--danger-color-hover);
  border-radius: 10px;
  padding: 10px 14px;
  margin-top: 8px;
`;
